import Theme from '../../theme';

export default (primary) => ({
  FULL: {
    backgroundColor: Theme.WHITE,
    color: primary,
    borderColor: primary,
  },
  SELECTED: {
    backgroundColor: Theme.CHARCOAL,
    color: Theme.GREY_LIGHT,
    borderColor: Theme.CHARCOAL,
  },
  AVAILABLE: {
    backgroundColor: Theme.WHITE,
    color: Theme.CHARCOAL,
    borderColor: Theme.CHARCOAL,
  },
  UNAVAILABLE: {
    backgroundColor: Theme.GREY_LIGHT,
    color: Theme.GREY_MEDIUM,
    borderColor: Theme.GREY_LIGHT,
  },
  WAITING_LIST: {
    backgroundColor: Theme.CHARCOAL,
    color: Theme.GREY_LIGHT,
    borderColor: Theme.CHARCOAL,
  },
  CURRENT_BOOKING: {
    backgroundColor: Theme.CHARCOAL,
    color: Theme.GREY_LIGHT,
    borderColor: Theme.CHARCOAL,
  },
  NOT_TYPESLOT_USER: {
    backgroundColor: Theme.GREY_LIGHT,
    color: Theme.GREY_MEDIUM,
    borderColor: Theme.GREY_LIGHT,
  },
});
